import * as menuBoardsQueries from './menuBoards/queries'
import * as establishmentQueries from './establishment/queries'

export const queries = {
    ...menuBoardsQueries,
    ...establishmentQueries,
}
